import {
    TWICL_END_DETAILS,
    TWICL_INITIAL_DETAILS,
    TWICL_QUALIFICATION_DETAILS
} from 'common/application.const/Licence/MyLicence/TWICLLicence';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatTWICL = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);

    licence = {
        id: 'telecommunication-wiring-installer-class-licence',
        formID: 'telecommunication-wiring-installer-class-licence',
        hasError: true,
        title: 'Licence Details',
        values: {
            [`${TWICL_INITIAL_DETAILS}-service-provided`]: licenceDetails?.ServiceDetails?.ServicesProvidedDesc ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-institution`]: licenceDetails?.QualificationDetails?.InstitutionDesc ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-certificate-number`]: licenceDetails?.QualificationDetails?.CertificateNo ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-course-name`]: licenceDetails?.QualificationDetails?.CourseNameDesc ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-completion-date`]: licenceDetails?.QualificationDetails?.CompletionDate ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-other-institution-name`]: licenceDetails?.QualificationDetails?.OtherInstitution ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-other-course-name`]: licenceDetails?.QualificationDetails?.OtherCourseName ?? '-',
            [`${TWICL_END_DETAILS}-proof-of-certificate`]: licenceDetails?.SupportingDocumentsAPImport?.ProofOfCertificate ?? '-',
        }
    };

    return licence;
};

const twiclPayload = {
    formatTWICL
};

export default twiclPayload;
